declare namespace $ {

	type $mol_card__title_rise_drag_demo_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $rise_drag_absolute__sub_rise_drag_demo_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_drag_absolute['sub'] >
	>
	type $rise_drag_absolute__drags_synced_rise_drag_demo_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_drag_absolute['drags_synced'] >
	>
	type $mol_card__title_rise_drag_demo_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $rise_drag_absolute__top_rise_drag_demo_5 = $mol_type_enforce<
		ReturnType< $rise_drag_demo['top'] >
		,
		ReturnType< $rise_drag_absolute['top'] >
	>
	type $rise_drag_absolute__left_rise_drag_demo_6 = $mol_type_enforce<
		ReturnType< $rise_drag_demo['left'] >
		,
		ReturnType< $rise_drag_absolute['left'] >
	>
	type $rise_drag_absolute__sub_rise_drag_demo_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_drag_absolute['sub'] >
	>
	export class $rise_drag_demo extends $mol_example_small {
		Card( ): $mol_card
		Draggable( ): $rise_drag_absolute
		top( next?: number ): number
		left( next?: number ): number
		Synced_drag( ): ReturnType< ReturnType< $rise_drag_demo['Synced'] >['Drag'] >
		Synced_card( ): $mol_card
		Synced( ): $rise_drag_absolute
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map